import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {TrainingPlanSelector} from './ui/TrainingPlanSelector';
import {TrainingPlanSelectorWithInitialData} from './ui/TrainingPlanSelectorWithInitialData';
import {DefaultComponent, setComponent} from './component';

const elements = Array.from(document.getElementsByClassName('training-plan-selector'));

elements.forEach((element) => {
    const data = element.getAttribute('data-value');
    setComponent(new DefaultComponent(JSON.parse(element.getAttribute('data-training-plans')!)));
    if (data) {
        const intiallySelectedTrainingPlanIds = JSON.parse(data);
        ReactDOM.render(
            <TrainingPlanSelectorWithInitialData intiallySelectedTrainingPlanIds={intiallySelectedTrainingPlanIds} />,
            element,
        );
    } else {
        ReactDOM.render(<TrainingPlanSelector />, element);
    }
});
